export const VIDEO_CURATED_PLAYLIST_UPDATE = "video_curated_playlist_update";
export const VIDEO_CURATED_PLAYLIST_NULL = "video_curated_playlist_null";
